import { ActivatedRoute } from '@angular/router';

export function extractRoute(route: ActivatedRoute, component: any): ActivatedRoute {
    if (route && route.component !== component) {
        return extractRoute(route.parent, component);
    }
    return route;
}
